module.exports = __webpack_public_path__ + "static/media/gc-chapter-3.4cb88725.png";